import { isProd } from "src/utilities/isProd";
import { getUserContext } from "./getUserContext";
import { onAgentMessageEnd } from "./onAgentMessageEnd";
import getTranslations from "src/i18n";
import { getAppVersion } from "./getAppVersion";
import noticeError from "src/app/utilities/noticeError";

export const getSierraConfig = async (onLoad) => {
  const userContext = await getUserContext();
  const translations = await getTranslations(userContext.language);

  const sierraConfig = {
    isProduction: isProd(),
    appVersion: getAppVersion(),
    logger: { error: noticeError },
    userContext: {
      ...userContext,
      login: window.asos.sdk.identity?.login,
      getAccessToken: window.asos.sdk.identity?.getAccessToken,
    },
    chatConfig: {
      onLoad,
      onAgentMessageEnd,
    },
    chatInterfaceStrings: {
      customGreeting: translations["cchp_ai_chat_greeting_message"].replace(
        "%{firstname}",
        `${userContext.firstName}`
      ),
      name: translations["cchp_ai_chat_header"],
      printTranscriptMenuLabel:
        translations["cchp_ai_chat_print_transcript_button"],
      disclosure: translations["cchp_ai_chat_disclosure"],
      endConversationMenuLabel: translations["cchp_ai_chat_end_chat_button"],
      errorMessage: translations["cchp_ai_chat_error_message"],
      conversationEndedMessage: translations["cchp_ai_chat_end_message"],
      agentTransferWaitingMessage:
        translations["cchp_ai_chat_agent_transfer_waiting_message"],
      agentTransferQueueNextMessage:
        translations["cchp_ai_chat_agent_transfer_queue_next_message"],
      agentTransferQueueSizeMessage:
        translations["cchp_ai_chat_agent_transfer_queue_size_message"],
      agentJoinedMessage:
        translations["cchp_ai_chat_agent_transfer_join_message"],
      agentLeftMessage: translations["cchp_ai_chat_agent_left_message"],
      newChatButtonLabel: translations["cchp_ai_chat_start_new_chat"],
      inputPlaceholder: translations["cchp_ai_chat_message_placeholder"],
    },
  };

  return sierraConfig;
};
